import React, { useRef } from "react";
import { FieldHint } from "../createEvent/CreateEventFormUi";
import { ReadableNavButton } from "../Sticker";
import {
  WorkflowModalShell,
  WorkflowModalHeader,
  WorkflowModalBody,
  WorkflowModalFooter,
} from "../workflow/WorkflowModal";

function creditCopy(impact) {
  if (!impact) return "Confirm this action for the student.";
  if (impact.will_debit_credits) {
    const after = impact.credits_remaining_after;
    return after == null
      ? "This will use 1 credit from their pack."
      : `This will use 1 credit. Pack will have ${after} remaining.`;
  }
  if (impact.via === "OFFER") {
    return "First Class Free — no pack credit will be deducted.";
  }
  if (impact.via === "TIME_PASS" || impact.via === "FREE_RULE") {
    return "Covered by a pass or free rule — no credit deduction.";
  }
  return "No credit will be deducted.";
}

export default function DoorAttendanceConfirmModal({
  mode,
  studentName,
  className,
  creditImpact,
  busy = false,
  onClose,
  onConfirmAttendance,
  onConfirmNoShow,
}) {
  const dialogRef = useRef(null);
  const isAttendance = mode === "attendance";
  const title = isAttendance ? "Mark attendance" : "Mark no-show";
  const name = studentName || "Student";

  return (
    <WorkflowModalShell
      dialogRef={dialogRef}
      onClose={onClose}
      onBackdropClose={busy ? undefined : onClose}
      testId="door-attendance-confirm"
      titleId="door-attendance-confirm-title"
      layout="sheet"
    >
      <WorkflowModalHeader
        sticky
        eyebrow={className || "Class"}
        title={title}
        titleId="door-attendance-confirm-title"
        onClose={busy ? undefined : onClose}
      />
      <WorkflowModalBody sheet className="space-y-3">
        <p className="font-ui text-[15px] text-ink">
          {isAttendance
            ? `Check in ${name} at the door?`
            : `${name} RSVP’d but didn’t show. How should credits be handled?`}
        </p>
        <FieldHint data-testid="door-credit-impact">
          {creditCopy(creditImpact)}
        </FieldHint>
      </WorkflowModalBody>
      <WorkflowModalFooter>
        {isAttendance ? (
          <div className="flex flex-wrap justify-end gap-2 w-full">
            <ReadableNavButton type="button" disabled={busy} onClick={onClose}>
              Cancel
            </ReadableNavButton>
            <ReadableNavButton
              type="button"
              variant="primary"
              disabled={busy}
              onClick={onConfirmAttendance}
              data-testid="door-confirm-attendance"
            >
              {busy ? "Saving…" : "Confirm check-in"}
            </ReadableNavButton>
          </div>
        ) : (
          <div className="flex flex-wrap justify-end gap-2 w-full">
            <ReadableNavButton type="button" disabled={busy} onClick={onClose}>
              Cancel
            </ReadableNavButton>
            <ReadableNavButton
              type="button"
              disabled={busy}
              onClick={() => onConfirmNoShow?.("FORGIVE")}
              data-testid="door-confirm-forgive"
            >
              {busy ? "Saving…" : "Forgive / Mark absent"}
            </ReadableNavButton>
            <ReadableNavButton
              type="button"
              variant="primary"
              disabled={busy}
              onClick={() => onConfirmNoShow?.("DEDUCT")}
              data-testid="door-confirm-deduct"
            >
              {busy ? "Saving…" : "Deduct credit"}
            </ReadableNavButton>
          </div>
        )}
      </WorkflowModalFooter>
    </WorkflowModalShell>
  );
}
